module.exports = __webpack_public_path__ + "img/exam3.859d4b6d.png";